import { render, staticRenderFns } from "./AddNewTags.vue?vue&type=template&id=0d021e6a&scoped=true&"
import script from "./AddNewTags.vue?vue&type=script&lang=js&"
export * from "./AddNewTags.vue?vue&type=script&lang=js&"
import style0 from "./AddNewTags.vue?vue&type=style&index=0&id=0d021e6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d021e6a",
  null
  
)

export default component.exports